import React from 'react'


interface Props {
  className?: string
}


const PodcastIconSvg: React.FC<Props> = (props) => {
  return (
    <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={props.className}><path d="M30.3 25.516l3.458-7.966-3.457-7.692M5.7 9.858l-3.458 7.966L5.7 25.516" stroke="#fff" strokeWidth="2.88" strokeMiterlimit="10" strokeLinecap="round" /><path d="M17.05 23.984c0 .271.102.532.284.724.182.193.429.3.686.3a.945.945 0 00.687-.3c.182-.192.284-.452.284-.724V11.682c0-.272-.102-.532-.284-.725a.945.945 0 00-.687-.3.945.945 0 00-.686.3 1.055 1.055 0 00-.284.725v12.302zM15.594 21.933v-8.2c0-.272-.103-.533-.285-.725a.945.945 0 00-.686-.3.945.945 0 00-.686.3 1.055 1.055 0 00-.285.725v8.2c0 .272.103.533.285.725.182.192.429.3.686.3a.945.945 0 00.686-.3c.182-.192.285-.453.285-.725zM11.226 20.908a.946.946 0 00.687-.3c.182-.192.284-.453.284-.725v-4.1c0-.272-.102-.533-.284-.725a.945.945 0 00-.687-.3.945.945 0 00-.686.3 1.055 1.055 0 00-.284.724v4.101c0 .272.102.533.284.725.182.192.43.3.686.3zM22.388 21.933v-8.2c0-.272-.102-.533-.284-.725a.945.945 0 00-.686-.3.945.945 0 00-.686.3 1.055 1.055 0 00-.285.725v8.2c0 .272.102.533.285.725.182.192.428.3.686.3a.945.945 0 00.686-.3c.182-.192.284-.453.284-.725zM24.815 14.757a.946.946 0 00-.686.3 1.055 1.055 0 00-.284.725v4.101c0 .272.102.533.284.725.182.192.429.3.686.3a.945.945 0 00.687-.3c.182-.192.284-.453.284-.725v-4.1c0-.272-.103-.533-.285-.725a.946.946 0 00-.686-.3z" fill="#11142D" /></svg>
  )
}


PodcastIconSvg.defaultProps = {
  className: 'w-8 h-8'
}


export default PodcastIconSvg;